import { render, staticRenderFns } from "./Testimonial.vue?vue&type=template&id=924659e4&"
import script from "./Testimonial.vue?vue&type=script&lang=js&"
export * from "./Testimonial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports